function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { ExternalUrls, LandingPageAnchorIds } from '@/utils/constants';
import LogoText from '../LogoText';
import DashboardButton from '../DashboardButton';
import { Anchor, Container } from '@mantine/core';
import styles from './NavBar.module.scss';
import classNames from 'classnames';
import useFragmentLink from '@/hooks/useFragmentLink';
export default function LandingNavBar(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var ref = React.useRef(null);
    var navigateTo = useFragmentLink(LandingPageAnchorIds.FEATURES);
    useEffect(function() {
        var handleScroll = function handleScroll() {
            window.requestAnimationFrame(function() {
                if (ref.current == null) {
                    return;
                }
                ref.current.classList.toggle(styles.scrolled, window.scrollY > 32);
            });
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        className: classNames(styles.navBarContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            className: styles.navBarInner,
            size: "xl",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.navBar,
                    children: /*#__PURE__*/ _jsx(LogoText, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.navLinks,
                    children: [
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: "button",
                            onClick: navigateTo,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "ZXp0z1",
                                defaultMessage: "Features"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            href: ExternalUrls.COMMUNITY_FORUM,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "HqRNN8",
                                defaultMessage: "Support"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            href: ExternalUrls.NIGHTDEV,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "p98kOH",
                                defaultMessage: "Our Products"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.actionButton,
                    children: /*#__PURE__*/ _jsx(DashboardButton, {
                        radius: "xl"
                    })
                })
            ]
        })
    }));
}
